/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/ban-types */
import React, { useEffect, useCallback, useState } from 'react';

import * as Yup from 'yup';
import { FormHandles, Scope } from '@unform/core';
import { FiUser, FiEdit, FiTrash2 } from 'react-icons/fi';

import getValidationErrors from '../../utils/getValidationErrors';
import convertToNumber from '../../utils/convertToNumber';

import Input from '../../components/Input';
import Button from '../../components/Button';

import {
  DependentsContainerActions,
  ListDependents,
  DependentsContent,
} from './styles';

interface DependentsProps {
  refProps: any | FormHandles;
}

interface DependentsFormDataDTO {
  name: string;
  phone: string;
}

interface ClientFormDataDTO {
  dependents?: Array<DependentsFormDataDTO>;
  // Estes dois campos são retirados do objeto no submit
  nameDependentFormAdd?: string;
  phoneDependentFormAdd?: string;
}

const Dependents: React.FC<DependentsProps> = ({ refProps }) => {
  const [listDependents, setListDependents] = useState<DependentsFormDataDTO[]>(
    [],
  );

  const [isVisibleFormDependents, setIsVisibleFormDependents] = useState(false);

  /** Inicia o scope dependents, sem isso ficar com a primeira posição em branco e
   * não preenche os campos */
  useEffect(() => {
    refProps.current?.setData({ dependents: listDependents });
  }, [listDependents, refProps]);

  // handleAddDependent
  const handleAddDependent = useCallback(async () => {
    try {
      // Limpa as mensagens de erro dos campos
      refProps.current?.setFieldError('nameDependentFormAdd', '');
      refProps.current?.setFieldError('phoneDependentFormAdd', '');

      // Cria este objeto para validação no YUP e já pega os valores dos campos
      const dataDependentAdd = {
        nameDependentFormAdd: refProps.current?.getFieldValue(
          'nameDependentFormAdd',
        ),
        phoneDependentFormAdd: refProps.current?.getFieldValue(
          'phoneDependentFormAdd',
        ),
      };

      const schema = Yup.object().shape({
        nameDependentFormAdd: Yup.string().required('Nome obrigatório'),
        phoneDependentFormAdd: Yup.string()
          .test('phoneDependentFormAdd', 'Telefone inválido', () => {
            return (
              convertToNumber(dataDependentAdd.phoneDependentFormAdd).length ===
              11
            );
          })
          .required('Telefone obrigatório'),
      });

      await schema.validate(dataDependentAdd, {
        abortEarly: false,
      });

      /*
        Pega os dados atuais do form, não utilizei o ...client pois perderia
        alterações do cliente ao adicionar um novo dependente. Usando o formRef.current?.getData()
        do unform, os dados são recuperados como se estivesse fazendo um submit, assim todos os dados
        que estiverem nos campos serão mantidos.
        */
      const dataForm = refProps.current?.getData() as ClientFormDataDTO;

      let newListDependents = [];

      if (!listDependents.length) {
        newListDependents.push({
          name: dataDependentAdd.nameDependentFormAdd,
          phone: dataDependentAdd.phoneDependentFormAdd,
        });
      } else {
        newListDependents = [...dataForm.dependents!];
        newListDependents.push({
          name: dataDependentAdd.nameDependentFormAdd,
          phone: dataDependentAdd.phoneDependentFormAdd,
        });
      }

      setListDependents(newListDependents);

      /** Sete os valores no scope dependents no form */
      refProps.current?.setData({ dependents: newListDependents });

      // Limpa os campos
      refProps.current?.clearField('nameDependentFormAdd');
      refProps.current?.clearField('phoneDependentFormAdd');
    } catch (error) {
      // Verifica se o error é do Yup ou seja dos campos
      if (error instanceof Yup.ValidationError) {
        const errors = getValidationErrors(error);
        refProps.current?.setErrors(errors);
      }
    }
  }, [listDependents, refProps]);
  // Fim handleAddDependent

  // handleRemoveDependent
  const handleRemoveDependent = useCallback(
    (index: number) => {
      listDependents.splice(index, 1);
      const newListDependents = [...listDependents];
      setListDependents(newListDependents);
    },
    [listDependents],
  );
  // Fim handleRemoveDependent

  // handleVisibleFormDependent
  const handleVisibleFormDependent = useCallback(() => {
    setIsVisibleFormDependents(!isVisibleFormDependents);
  }, [isVisibleFormDependents]);
  // Fim handleVisibleFormDependent

  return (
    <>
      <DependentsContent>
        {(!isVisibleFormDependents && (
          <Button
            name="activeFormDependents"
            type="button"
            onClick={handleVisibleFormDependent}
          >
            Adicionar Dependentes
          </Button>
        )) || (
          <>
            <h1>Cadastro de Dependentes</h1>

            <Input
              type="text"
              name="nameDependentFormAdd"
              icon={FiUser}
              placeholder="Nome Completo"
              maxLength={45}
            />
            <Input
              type="text"
              name="phoneDependentFormAdd"
              icon={FiEdit}
              placeholder="Telefone"
              mask="(99) 9 9999-9999"
            />

            <DependentsContainerActions>
              <Button
                name="addDependent"
                type="button"
                onClick={handleAddDependent}
              >
                +
              </Button>

              <Button
                name="activeFormDependents"
                onClick={handleVisibleFormDependent}
              >
                Cancelar
              </Button>
            </DependentsContainerActions>
          </>
        )}
      </DependentsContent>
      {listDependents.length > 0 && (
        <DependentsContent>
          <h2>Lista de Dependentes</h2>
          {listDependents.map((item, index) => (
            <ListDependents key={index.toString()}>
              <Scope path={`dependents[${index}]`}>
                <Input
                  type="text"
                  name="name"
                  icon={FiUser}
                  placeholder="Nome Completo"
                  maxLength={45}
                />
                <Input
                  type="text"
                  name="phone"
                  icon={FiEdit}
                  placeholder="Telefone"
                  mask="(99) 9 9999-9999"
                  required
                />
              </Scope>
              <DependentsContainerActions>
                <FiTrash2
                  size={24}
                  onClick={() => {
                    handleRemoveDependent(index);
                  }}
                />
              </DependentsContainerActions>
            </ListDependents>
          ))}
        </DependentsContent>
      )}
    </>
  );
};

export default Dependents;
